import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const generatePDFFromComponent = async (
  componentRef,
  filename,
  onStart = () => {},
  onComplete = () => {},
  onError = (error) => console.error("Error generating PDF:", error)
) => {
  if (!componentRef.current) {
    onError(new Error("Component reference is not available"));
    return;
  }

  onStart();

  try {
    const element = componentRef.current;

    const width = element.scrollWidth;
    const height = element.scrollHeight;

    const canvas = await html2canvas(element, {
      scale: 1.5,
      backgroundColor: "#f5f7f9",
      logging: false,
      useCORS: true,
      allowTaint: true,
      imageTimeout: 0,
      width: width,
      height: height,
    });

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const pdf = new jsPDF({
      orientation: imgWidth > imgHeight ? "landscape" : "portrait",
      unit: "px",
      format: [imgWidth, imgHeight],
      compress: true,
    });

    pdf.addImage(canvas.toDataURL("image/jpeg", 0.8), "JPEG", 0, 0, imgWidth, imgHeight);

    pdf.save(filename);
    onComplete();
  } catch (error) {
    onError(error);
  }
};

export const generateTestCaseReportPDF = (
  componentRef,
  testCaseName,
  runDate,
  onStart = () => {},
  onComplete = () => {},
  onError = (error) => console.error("Error generating test case report PDF:", error)
) => {
  const filename = `TestCase-Report-${testCaseName}-${runDate}.pdf`;
  generatePDFFromComponent(componentRef, filename, onStart, onComplete, onError);
};


export const generateTestSuiteReportPDF = (
  componentRef,
  testSuiteName,
  onStart = () => {},
  onComplete = () => {},
  onError = (error) => console.error("Error generating test suite report PDF:", error)
) => {
  const filename = `Execution-Report-${testSuiteName}.pdf`;
  generatePDFFromComponent(componentRef, filename, onStart, onComplete, onError);
}; 